import { render, staticRenderFns } from "./SummaryRevenueCountry.vue?vue&type=template&id=2efee85d&scoped=true&"
import script from "./SummaryRevenueCountry.vue?vue&type=script&lang=js&"
export * from "./SummaryRevenueCountry.vue?vue&type=script&lang=js&"
import style0 from "./SummaryRevenueCountry.vue?vue&type=style&index=0&id=2efee85d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efee85d",
  null
  
)

export default component.exports